var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import BS_Carousel from 'bootstrap/js/dist/carousel';
export class Carousel extends Component {
    constructor() {
        super('CarouselComponent', true);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.carousel').forEach((carousel) => {
                Carousel.initCarousel(carousel);
                Carousel.fixButtonsTop(carousel);
                Carousel.fixCaptionHeight(carousel);
            });
            $(window).on('resize', () => {
                $('.carousel').forEach((carousel) => {
                    Carousel.fixButtonsTop(carousel);
                    Carousel.fixCaptionHeight(carousel);
                });
            });
            this.success();
        });
    }
    static initCarousel(carousel) {
        const bsCarousel = new BS_Carousel(carousel, {
            interval: 5000,
            ride: false,
            pause: $(carousel).data('paused') == 'true' ? false : 'hover',
        });
        if ($(carousel).data('paused') != 'true') {
            bsCarousel.cycle();
        }
    }
    static fixButtonsTop(carousel) {
        console.log('Fixing buttons top for carousel');
        $(carousel).find('.carousel-item').removeClass('active').first().addClass('active');
        const height = $(carousel).find('img').get(0).getBoundingClientRect().height;
        $(carousel).find('button').forEach((button) => {
            button.style.top = (height / 2) + 'px';
        });
    }
    static fixCaptionHeight(carousel) {
        const carouselItems = $(carousel).find('.carousel-item');
        carouselItems.find('.gallery-caption').css('height', 'auto');
        let height = 0;
        carouselItems.forEach((carouselItem) => {
            if ($(carouselItem).find('.gallery-caption').length === 0)
                return;
            $(carousel).find('.carousel-item').removeClass('active');
            $(carouselItem).addClass('active');
            const captionHeight = $(carouselItem).find('.gallery-caption').get(0).getBoundingClientRect().height;
            if (captionHeight > height) {
                height = captionHeight;
            }
        });
        carouselItems.find('.gallery-caption').css('height', height + 'px');
        $(carousel).find('.carousel-item').removeClass('active').first().addClass('active');
    }
}
